// @flow

import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import Menu from './';

type Props = {};

type State = {
  isOpen: boolean,
  checkStatus: Array<boolean>,
};

class MenuContainer extends Component<Props, State> {
  state = {
    isOpen: false,
    checkStatus: [false, false, false, false],
  };

  componentDidMount() {
    const uncheckInputs = () => {
      if (window.innerWidth > 1194) {
        this.setState(prevState => {
          return {
            ...prevState,
            checkStatus: [false, false, false, false],
          };
        });
      }
    };
    window.addEventListener('resize', debounce(uncheckInputs, 10));
  }

  handleToggleClick() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  handleMenuClick() {
    this.setState({
      isOpen: false,
    });
  }

  changeCheckStatus(index) {
    this.setState(prevState => {
      return {
        ...prevState,
        checkStatus: prevState.checkStatus.map((item, indexItem) =>
          indexItem === index ? !item : item,
        ),
      };
    });
  }

  render() {
    return (
      <Menu
        isOpen={this.state.isOpen}
        onMenuClick={this.handleMenuClick.bind(this)}
        onToggleClick={this.handleToggleClick.bind(this)}
        checkStatus={this.state.checkStatus}
        changeCheckStatus={this.changeCheckStatus.bind(this)}
      />
    );
  }
}

export default MenuContainer;



// WEBPACK FOOTER //
// ./src/components/Header/partials/Menu/container.js